module.exports = __webpack_public_path__ + "static/media/collateralMaker.d4228788.svg";